import { CommerceSale } from '@ts/operations'
import { DateTime } from 'luxon'
import React from 'react'

import ReleasePhaseList from './ReleasePhaseList'

const SalesProvider = ({ sales }: { sales: Array<CommerceSale> }) => {
  if (!sales) {
    return null
  }

  const listSales = sales?.map(hit => {
    const { id, name, endDate, startDate } = hit
    const now = DateTime.local().setZone('UTC')
    const isActive =
      DateTime.fromISO(startDate.toString()) < now && DateTime.fromISO(endDate.toString()) >= now
    return {
      active: isActive || false,
      endsAt: DateTime.fromISO(endDate.toString()),
      id,
      name,
    }
  })

  if (!listSales || listSales.length < 2) {
    return null
  }

  return <ReleasePhaseList phases={listSales} />
}

export default SalesProvider
